import { render, staticRenderFns } from "./ContributionsPieChart.vue?vue&type=template&id=4eac2428&scoped=true"
import script from "./ContributionsPieChart.vue?vue&type=script&lang=ts"
export * from "./ContributionsPieChart.vue?vue&type=script&lang=ts"
import style0 from "./ContributionsPieChart.vue?vue&type=style&index=0&id=4eac2428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eac2428",
  null
  
)

export default component.exports